import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from '@vectord/components';

function TableRow({ children, className, forwardedRef, ...remainingProps }) {
  return (
    <tr
      ref={forwardedRef}
      className={classNames(className)}
      {...remainingProps}
    >
      {children}
    </tr>
  );
}

TableRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default forwardRef(TableRow);
